
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/journal/articles/[uid]",
      function () {
        return require("private-next-pages/journal/articles/[uid].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/journal/articles/[uid]"])
      });
    }
  